import styled from "styled-components";

export const MobileTable = styled.div`
  padding-bottom: ${({ theme }) => theme.getValue(40)}px;
`;

export const MobileTableHeader = styled.div`
  min-height: 1px;
`;

export const MobileTableStickyHeader = styled.div<{
  active?: boolean;
  backgroundColor?: string;
}>`
  position: fixed;
  z-index: ${({ active }) => (active ? 20 : -1)};
  top: 0;
  left: 0;
  width: 100%;
  padding: ${({ theme }) => `0 ${theme.getValue(8)}px`};
  transition: opacity 0.2s;
  background: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.green4};
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.3);
  opacity: ${({ active }) => (active ? 1 : 0)};
`;

export const MobileTableBody = styled.div``;

export const MobileTableRow = styled.div<{
  divider?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ theme }) =>
    `minmax(${theme.getValue(114)}px, 1fr)`};
  grid-auto-flow: column;
  grid-auto-columns: ${({ theme }) => theme.getValue(114)}px;
  column-gap: ${({ theme }) => theme.getValue(8)}px;
  border-top: ${({ theme, divider }) =>
    divider ? `1px solid ${theme.colors.grey8}` : 0};
`;

export const MobileToggleColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const DesktopTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`;

export const DesktopTableHeader = styled.thead`
  min-height: 1px;
`;

export const DesktopTableBody = styled.tbody`
  display: block;
`;

export const DesktopTableHeaderRef = styled.thead`
  min-height: 1px;
`;

export const DesktopTableRow = styled.tr<{
  fluid?: boolean;
  showScrollBar?: boolean;
  backgroundColor?: string;
  sticky?: boolean;
  showShadow?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ theme, fluid }) =>
    fluid ? `1fr 0px` : `minmax(${theme.getValue(554)}px, 1fr)`};
  grid-auto-flow: column;
  grid-auto-columns: ${({ theme }) =>
    `minmax(${theme.getValue(276)}px, min-content)`};
  box-shadow: ${({ showShadow }) =>
    showShadow ? "0px 2px 12px rgba(0, 0, 0, 0.3);" : "none"};
`;

export const DesktopTableColumn = styled.td`
  padding-right: ${({ theme }) => theme.getValue(16)}px;

  &:last-child {
    padding-right: 0;
  }
`;

export const DesktopTableStickyColumn = styled.td<{
  backgroundColor?: string;
}>`
  position: sticky;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  background: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.green4};
`;
